import './SuperAdminCustomerMgmnt.scss'
import {buttonColors} from "../../Pickers/InputTheme";
import {i18n} from "../../../Utils/i18n/i18n";
import {Button} from "../../Form/Button/Button";
import React, {useState} from "react";
import {GridReactContextProvider} from "../../../Utils/DataGridWrapper/GridContext";
import {SuperAdminCustomersTable} from "../SuperAdminCustomersTable/SuperAdminCustomersTable";
import {SuperAdminCreateNewCustomerModal} from "../SuperAdminCreateNewCustomer/SuperAdminCreateNewCustomerModal";
import {SA_downloadCompaniesReportAPI, SA_runRecurringRenewalCronJobsAPI} from "../../../Services/SA_api";
import '../SuperAdminPage.scss'

export const SuperAdminCustomerMgmnt = () => {
    const [isCreateNewCustomerModalOpen, setIsCreateNewCustomerModalOpen] = React.useState(false)
    const [isDownloadingReport, setIsDownloadingReport] = useState(false)
    const [isRenewalRunning, setIsRenewalRunning] = useState(false)

    const openCreateNewCustomerModal = () => {
        setIsCreateNewCustomerModalOpen(true)
    }
    const closeCreateNewCustomerModal = () => {
        setIsCreateNewCustomerModalOpen(false)
    }

    const handleRunRecurringRenewal = async () => {
        try {
            setIsRenewalRunning(true);
            await SA_runRecurringRenewalCronJobsAPI();
            alert(i18n.translate('superAdmin.cronJobs.renewalSuccess'));
        } catch (error) {
            console.error('Error running recurring renewal:', error);
            alert(i18n.translate('superAdmin.cronJobs.renewalError'));
        } finally {
            setIsRenewalRunning(false);
        }
    };

    const handleDownloadReport = async () => {
        try {
            setIsDownloadingReport(true);
            const response = await SA_downloadCompaniesReportAPI();
            const downloadUrl = response.downloadUrl;

            if (!downloadUrl) {
                console.error('No downloadUrl received from API');
                alert(i18n.translate('superAdmin.customersTable.reportError'));
                return;
            }

            window.open(downloadUrl, '_blank');
            console.log(i18n.translate('superAdmin.customersTable.reportGenerated'));
        } catch (error) {
            console.error('Error downloading companies report:', error);
            alert(i18n.translate('superAdmin.customersTable.reportError'));
        } finally {
            setIsDownloadingReport(false);
        }
    };

    return <div className="SuperAdminCustomerMgmnt SuperAdminPage">
        <div className="buttonsWrapper">
            <Button color={buttonColors.GREY}
                    text={i18n.translate('superAdmin.createNewCustomer.modalTitle')}
                    onClick={openCreateNewCustomerModal}/>
            <Button color={buttonColors.GREY}
                    text={isDownloadingReport
                        ? i18n.translate('superAdmin.customersTable.downloadingReport')
                        : i18n.translate('superAdmin.customersTable.downloadReport')}
                    onClick={handleDownloadReport}
                    disabled={isDownloadingReport}/>
            <Button color={buttonColors.GREY}
                    text={isRenewalRunning
                        ? i18n.translate('superAdmin.cronJobs.running')
                        : i18n.translate('superAdmin.cronJobs.runRecurringRenewal')}
                    onClick={handleRunRecurringRenewal}
                    disabled={isRenewalRunning}
                    loading={isRenewalRunning}/>
        </div>
        <GridReactContextProvider>
            <div className="superAdminCustomersTableWrapper">
                <SuperAdminCustomersTable/>
            </div>
            <SuperAdminCreateNewCustomerModal
                createCustomerModalOpen={isCreateNewCustomerModalOpen}
                onUserCreated={closeCreateNewCustomerModal}
                closeCreateCustomerModal={closeCreateNewCustomerModal}/>
        </GridReactContextProvider>
    </div>
}